import calculadora from "./calculadora";

export function presente_value(rate, nper, pmt)
{
    return pmt / rate * (1 - Math.pow(1 + rate, -nper));
}


export function pgto(prazo_acumulacao, taxa_efetiva_mensal, valor_presente, valor_futuro)
{

    const result = calculadora(3, [prazo_acumulacao, taxa_efetiva_mensal * 100, valor_presente, 0, valor_futuro]);

    return result[3]
}


export function taxa_efetiva_mensal(porcentagem) {

    return (((porcentagem * 0.01) + 1) ** (1/12) - 1)
}



// WEBPACK FOOTER //
// ./src/helpers/calculo_financeiro.js